import { axiosGet, axiosPost } from "../../apis/useAxios";

// Configuration › Booking Hotel Priority. Only this page's own API (hotel-booking-priority/*).

const airlineCode = () => sessionStorage.getItem("session_airlineCode") ?? "";
const userName = () => sessionStorage.getItem("session_userName") ?? "";

const payloadOrThrow = (response, fallback) => {
  if (!response || (response.isSuccess === false && !/no record/i.test(response.message ?? ""))) throw new Error(response?.message || fallback);
  return response.payload ?? [];
};

/** The ranked hotels of every airport (or one): [{ id, airportCode, crewType, hotelCode, hotelName, priority, updatedBy, updatedAt }]. */
export async function getPriorities(airportCode = "", options) {
  return payloadOrThrow(
    await axiosGet("hotel-booking-priority/list", { airlineCode: airlineCode(), airportCode }, options),
    "Unable to load the hotel priorities.",
  );
}

/** Active hotels of the airport: [{ hotelCode, hotelName, listedFor: "P,F" }]. */
export async function getHotelOptions(airportCode, options) {
  return payloadOrThrow(
    await axiosGet("hotel-booking-priority/hotel-options", { airlineCode: airlineCode(), airportCode }, options),
    "Unable to load the hotels.",
  );
}

/** Adds the hotel at the end of the lists of crewTypes (["P"], ["F"] or both). */
export function addPriorityHotel({ airportCode, hotelCode, crewTypes }) {
  return axiosPost("hotel-booking-priority/add", { airlineCode: airlineCode(), userName: userName(), airportCode, hotelCode, crewTypes });
}

/** Saves the new order of one list (every hotel code, first = priority 1). */
export function reorderPriority({ airportCode, crewType, hotelCodes }) {
  return axiosPost("hotel-booking-priority/reorder", { airlineCode: airlineCode(), userName: userName(), airportCode, crewType, hotelCodes });
}

/** Removes one hotel (row id) from its list; the hotels after it move up. */
export function removePriorityHotel({ airportCode, id }) {
  return axiosPost("hotel-booking-priority/remove", { airlineCode: airlineCode(), userName: userName(), airportCode, id });
}
